import React from "react";

import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";

import { ReactComponent as HistoryIcon } from "../../../../assets/images/subscriptions/history-fill.svg";
import { ReactComponent as MapPinIcon } from "../../../../assets/images/subscriptions/map-pin-line.svg";
import { ReactComponent as TestTubeIcon } from "../../../../assets/images/subscriptions/test-tube-line.svg";

import "./UsageInsightCards.css";

const INSIGHT_ICONS = {
  flask: TestTubeIcon,
  pin: MapPinIcon,
  history: HistoryIcon,
};

const DETAIL_TONE_CLASS = {
  positive: "UsageInsightCards__Detail--positive",
  negative: "UsageInsightCards__Detail--negative",
  muted: "UsageInsightCards__Detail--muted",
};

export default function UsageInsightCards({ insights = [] }) {
  if (!insights.length) return null;

  return (
    <aside className="UsageInsightCards">
      {insights.map((insight) => {
        const InsightIcon = INSIGHT_ICONS[insight.icon];
        const showDetail = Boolean(insight.detail || insight.detailHighlight);

        return (
          <article className="UsageInsightCards__Card" key={insight.key}>
            <span className="UsageInsightCards__Icon" aria-hidden>
              {InsightIcon ? (
                <InsightIcon className="UsageInsightCards__IconImg" />
              ) : null}
            </span>
            <div className="UsageInsightCards__Content">
              <p className="UsageInsightCards__Label">{insight.label}</p>
              <p className="UsageInsightCards__Value">{insight.value}</p>
              {showDetail ? (
                <p
                  className={[
                    "UsageInsightCards__Detail",
                    DETAIL_TONE_CLASS[insight.detailTone] || DETAIL_TONE_CLASS.muted,
                  ].join(" ")}
                >
                  {insight.detailTone === "positive" && <ArrowUpOutlined />}
                  {insight.detailTone === "negative" && <ArrowDownOutlined />}
                  {insight.detailHighlight ? (
                    <>
                      <span className="UsageInsightCards__DetailHighlight">
                        {insight.detailHighlight}
                      </span>
                      {insight.detail ? ` ${insight.detail}` : null}
                    </>
                  ) : insight.detail}
                </p>
              ) : null}
            </div>
          </article>
        );
      })}
    </aside>
  );
}
